import { render, staticRenderFns } from "./practice_list.vue?vue&type=template&id=7d65007b&"
import script from "./practice_list.vue?vue&type=script&lang=js&"
export * from "./practice_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports